import { isAiConfigAvailableForUser } from 'shared-helpers/aiTools';
import { useReduxState } from 'hooks';
import { PageInnerContent, PageSidebar } from 'components/page';
import { UserPage } from 'components/user';
import { ProfilePage } from '.';

const ProfileCompetenciesPage = ({
  activeLink = '',
  children = null,
  isUserPage = false
}) => {
  const {
    messages,
    pageState: { user },
    serverConfig,
    user: loggedInUser
  } = useReduxState();

  const basePath = isUserPage ? `/users/${user?.id}` : '/profile';

  const competencyMappingEnabled = isAiConfigAvailableForUser({
    requiredAiExtraServerConfig: 'aiExtraCompetencyMapping',
    requireAiToolsPermission: false,
    serverConfig,
    user: loggedInUser
  });

  const sidebarLinks = user
    ? [
        ...(serverConfig.featureFlags.enableCompetencyImprovements
          ? [
              {
                href: `${basePath}/competencies`,
                icon: 'medal' as const,
                title: messages.commonCompetencies
              },
              {
                href: `${basePath}/competency-profiles`,
                icon: 'address-card' as const,
                title: messages.competencyProfiles
              }
            ]
          : []),
        ...(competencyMappingEnabled
          ? [
              {
                href: `/profile/competency-mappings`,
                icon: 'wand-magic-sparkles' as const,
                title: messages.competencyMappings
              }
            ]
          : [])
      ]
    : null;

  if (isUserPage) {
    return (
      <UserPage activeLink="/competencies" withSidebar={true}>
        <PageSidebar active={`${basePath}${activeLink}`} links={sidebarLinks} />
        <PageInnerContent>{children}</PageInnerContent>
      </UserPage>
    );
  }

  return (
    <ProfilePage activeLink="/competencies" withSidebar={true}>
      <PageSidebar active={`${basePath}${activeLink}`} links={sidebarLinks} />
      <PageInnerContent>{children}</PageInnerContent>
    </ProfilePage>
  );
};

export default ProfileCompetenciesPage;
